<!-- Modal -->
<div class="modal modal-blur fade" id="urun-grup-sec-modal" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Ürün Grubu Seç</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="mb-3" *ngFor="let s of urunGrupArray;let i = index;">
          <div class="form-label" [innerText]="s.id==null?'Ürün Grubu':'Alt Ürün Grubu'"></div>
          <select class="form-control" (change)="changedSelected(i,$event)">
            <option [value]="null" disabled selected>Seçiniz</option>
            <option *ngFor="let p of s.childrens" [value]="p.id">{{p.isim}}</option>
          </select>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Kapat</button>
      </div>
    </div>
  </div>
</div>

<!-- Modal -->
